var _path, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomizeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M75 0H35C15.67 0 0 15.67 0 35V75C0 94.33 15.67 110 35 110H75C94.33 110 110 94.33 110 75V35C110 15.67 94.33 0 75 0Z",
    fill: "#2563FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 46,
    height: 46,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_462",
    transform: "scale(0.0217391)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_462",
    width: 46,
    height: 46,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAABHNCSVQICAgIfAhkiAAABNJJREFUaIHt2WuoXcUVB/DfObm+qoiKWnzUB3gnRktBpaaUfqgKaowaRVExWNE7ShWbKKmmFvqtHxSUxvhAcdQgiiBEa33EZ3wgVFtfVKxl1A8afAUt8UHV1uT0w94nd+fcfe4995x7ckH8w4a115o18z9z1qw9a6bRarWEaHcswxnYHk/g2py8bhYRon1KXiegiYdwXU7ebYyOtfYoFUd2+P0bC3Lyt63KtkSI5uMuHNRhehsnjOC3JpKG3bAyRL8fIr8NOXmli+14E0krdX9sjI613sV+Q6M2OVpYlpM/dRpC1MRVuLzG7/0RRUzPFhoqkxain+AcLM/JJlwRohau6PDbZkSxEBd36Xgdbu+D0IH4VSk/i2e6tFuPu0vSh2M1DsDuIbogJ9/mZHmIvsEfKn7vNEbHWofiOUVMd+LcnNw5XdYhOhIvlq9X5uSqKdofjKewd0V9W05ipc3Vxmf+lGZO3sBCPF9xegfn90O6xE4VedJQDNE8rOkgDWMhurX9kpPlWKFYEw+MlMoXQvS7CvlVObmjT9I9I0Q/xl8U4VGHGKL/YUkZNpe1Dc1Ko20r8sjM09wSIToEf1ash8lwEVaFuCWn6ktjhrl1RYjm4hHs36PL69hUVQxrZudU5Oq/KkRH4H78qMe+Yk5u61Q261rOAD6pyF+0hXKmV+ud9NI60gxpxnPyaohOVyy6O9mc8h7XO+klObm+9F2EnXFXTloMcRHmZHVbLlPeI3onfUlObix9D1csYop/cg3DC5XNKFPew7qnvE78pk26RPXDuE9bGGraC9EoHq0OOAlauDQnN3Toq9lkY1sY9ox/hn/22DbmZGWvHQ+FeIh2hJysV1RV3TZZbSzNaXqbuRknXqa8v4foYsjJBpyk2CXWYel0ZrqNbsS/mW5HEKIf4jHMw3UhuhBy8iVONnHml/RA+j91ym6Lc36IzuuB60c5FempxGLjn/ER3Byi7XOyMiefh+hUxQfoaFumvOOxV5cx5k2H+KLymRIhOjMn95avZ3eYG1gRok05uSEnG0K0GD/PyX2l/3Fs8eN7wkykw1ZJYC4OrbE3cH2INuLmnHxEQbrqP110I/5A+UyFD3PyaCkfY/Ki4SY8jX9VlTl5PEQLTB4qEwrmbsRf7KOQOGsK+2V4q85Q+fETEKKfmQbx7aYg0dn5IvyixvQpXsKKychNgR/UKQeO8RAtxD3GC5EvFBuqB7E2Jx8OOkYdBiIeogNxL3YoVStxTU7WDUpsKgw64xuNb3xuycnStiFEe2PPnLw24Bi1GOiTn5P3MB/H5OTXbX2I9sNf8XKIE3L7jGDgGM/Jm3izQz3X+NHaIYOOUYdhbWs3VuRvhzHA0CugYeF74lsb3wni1Q17X4XEkFDl9XVbaEKI9mf8JBSnheiorUSsK8rzmOod1IXlOYtmeSW3RlHUtnEEngjRsX2O+VVF/m8/HYQoKOrUkyrqX+LJEP10BFeqL4/m4JoQXdrHuIdV5LkhOrqPPpZhjxr9rri6MTrWWod9++h4NrG+iW1mm0UfmDOi2Dt3q+gzk188DRHnqy9OIDdGx1qjWKs+XE7NafNJ6VZFeef5LHbpMH2FE5s5eQsLFEe5HyjuHp/HKbNFGnLyDxyrOFP/AB8rs0xO1v4fJ5NM9PJxOEkAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeIcon);
export default __webpack_public_path__ + "static/media/customize-icon.058e99ce590df63915bea95b22bc023d.svg";
export { ForwardRef as ReactComponent };